module.exports = __webpack_public_path__ + "img/back-arrow.88f43449.svg";